const deliveryInfoFields = [
  {
    key: 0,
    title: 'Адрес доставки:',
    name: 'address',
  },
  {
    key: 1,
    title: 'Трек-номер:',
    name: 'tracking_number',
  },
  {
    key: 2,
    title: 'Комментарий пользователя:',
    name: 'comment_user',
  },
  {
    key: 3,
    title: 'Комментарий администратора:',
    name: 'comment_admin',
  },
];

export { deliveryInfoFields };
